<!--
 * @Author: 月魂
 * @Date: 2021-01-27 14:14:55
 * @LastEditTime: 2022-01-20 14:04:32
 * @LastEditors: 月魂
 * @Description: 
 * @FilePath: \bingmayong-ukraine-mobile\src\App.vue
-->
<template>
  <div id="app">
    <!-- 此处可以放置header -->
    <router-view />
    <!-- 此处可以放置footer -->
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    // 判断移动端还是pc端
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  },
  mounted: function () {
    if (!this._isMobile()) {
      window.location.href = 'http://tst.ukr-qin.topartsintermational.com'
    }
  },
}
</script>

<style lang="less">
@font-face {
  font-family: ping;
  src: url('http://image.wearetogether.com.cn/pingfang.TTF');
}
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
body {
  margin: 0;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
#app {
  font-family: ping, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: justify;
  font-size: 14px;
}
.title {
  font-size: 20px;
  font-weight: bold;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  z-index: 2;
}
.van-popup {
  background-color: rgba(0, 0, 0, 0) !important;
}
// 轮播图指示器位置上调
.van-swipe__indicators {
  bottom: 10% !important;
}
</style>
